import { render, staticRenderFns } from "./VehicleStatusPanel.vue?vue&type=template&id=4fde9087&scoped=true"
import script from "./VehicleStatusPanel.vue?vue&type=script&lang=js"
export * from "./VehicleStatusPanel.vue?vue&type=script&lang=js"
import style0 from "./VehicleStatusPanel.vue?vue&type=style&index=0&id=4fde9087&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fde9087",
  null
  
)

export default component.exports